import { navItemStyles } from './styles';
import { cn } from '@/lib/utils';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonHTMLAttributes, DetailedHTMLProps, ReactNode } from 'react';

export function NavItemButton({
  children,
  className,
  ...props
}: DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> & { children: ReactNode }) {
  return (
    <button
      className={cn(
        navItemStyles(),
        'flex items-center justify-between w-full',
        className,
      )}
      {...props}>
      {children}
      <FontAwesomeIcon icon={faChevronRight} className="text-neutrals-700" />
    </button>
  );
}
